import React from 'react';

const CompanySettingsModal = ({
  open,
  onClose,
  form,
  setForm,
  status,
  saving,
  uploadingLogo,
  onSave,
  onUploadLogo,
  toAbsoluteUrl
}) => {
  if (!open) return null;
  const normalizeHex = (value, fallback) => {
    if (typeof value !== 'string') return fallback;
    let raw = value.trim();
    if (!raw) return fallback;
    if (!raw.startsWith('#') && /^[0-9a-fA-F]{3,6}$/.test(raw)) raw = `#${raw}`;
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(raw)) return fallback;
    return raw.toLowerCase();
  };
  const primaryValue = normalizeHex(form.brandPrimary, '#2563eb');
  const secondaryValue = normalizeHex(form.brandSecondary, '#0ea5e9');

  return (
    <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.45)' }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Datos de empresa</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            {status && (
              <div className={`alert alert-${status.type === 'error' ? 'danger' : status.type} py-2`}>
                {status.message}
              </div>
            )}
            <div className="mb-2">
              <label className="form-label">Razón Social</label>
              <input className="form-control" value={form.name} onChange={(e) => setForm((p) => ({ ...p, name: e.target.value }))} />
            </div>
            <div className="mb-2">
              <label className="form-label">NIF / CIF</label>
              <input className="form-control" value={form.cif} onChange={(e) => setForm((p) => ({ ...p, cif: e.target.value }))} />
            </div>
            <div className="mb-2">
              <label className="form-label">Dirección</label>
              <input className="form-control" value={form.address} onChange={(e) => setForm((p) => ({ ...p, address: e.target.value }))} />
            </div>
            <div className="row g-2">
              <div className="col-md-4">
                <label className="form-label">Código postal</label>
                <input className="form-control" value={form.zip} onChange={(e) => setForm((p) => ({ ...p, zip: e.target.value }))} />
              </div>
              <div className="col-md-8">
                <label className="form-label">Población</label>
                <input className="form-control" value={form.city} onChange={(e) => setForm((p) => ({ ...p, city: e.target.value }))} />
              </div>
            </div>
            <div className="row g-2 mt-2">
              <div className="col-md-6">
                <label className="form-label">Provincia</label>
                <input className="form-control" value={form.province} onChange={(e) => setForm((p) => ({ ...p, province: e.target.value }))} />
              </div>
              <div className="col-md-6">
                <label className="form-label">País</label>
                <input className="form-control" value={form.country} onChange={(e) => setForm((p) => ({ ...p, country: e.target.value }))} />
              </div>
            </div>
            <div className="mt-2">
              <label className="form-label">Cuenta bancaria (IBAN)</label>
              <input
                className="form-control"
                value={form.bankAccount || ''}
                onChange={(e) => setForm((p) => ({ ...p, bankAccount: e.target.value }))}
                placeholder="ES00 0000 0000 0000 0000 0000"
              />
            </div>
            <div className="mt-3">
              <label className="form-label d-flex align-items-center justify-content-between">
                <span>Logotipo</span>
                <small className="text-muted">{uploadingLogo ? 'Subiendo...' : ''}</small>
              </label>
              <div className="d-flex align-items-center gap-3">
                <label className="btn btn-outline-secondary mb-0">
                  Subir imagen
                  <input
                    type="file"
                    accept="image/*"
                    hidden
                    onChange={(e) => onUploadLogo(e.target.files?.[0])}
                    disabled={uploadingLogo}
                  />
                </label>
                {form.logoUrl && (
                  <img src={toAbsoluteUrl(form.logoUrl)} alt="Logo" style={{ maxHeight: 50, maxWidth: 120 }} />
                )}
              </div>
              <small className="text-muted">Formatos: jpg, png, webp. Tamaño máximo 5MB.</small>
            </div>
            <div className="row g-2 mt-3">
              <div className="col-12 col-md-6">
                <label className="form-label">Color principal</label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    className="form-control form-control-color"
                    value={primaryValue}
                    onChange={(e) => setForm((p) => ({ ...p, brandPrimary: e.target.value }))}
                  />
                  <input
                    type="text"
                    className="form-control"
                    value={form.brandPrimary || ''}
                    placeholder={primaryValue}
                    onChange={(e) => setForm((p) => ({ ...p, brandPrimary: e.target.value }))}
                  />
                </div>
              </div>
              <div className="col-12 col-md-6">
                <label className="form-label">Color secundario</label>
                <div className="d-flex align-items-center gap-2">
                  <input
                    type="color"
                    className="form-control form-control-color"
                    value={secondaryValue}
                    onChange={(e) => setForm((p) => ({ ...p, brandSecondary: e.target.value }))}
                  />
                  <input
                    type="text"
                    className="form-control"
                    value={form.brandSecondary || ''}
                    placeholder={secondaryValue}
                    onChange={(e) => setForm((p) => ({ ...p, brandSecondary: e.target.value }))}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-outline-secondary" onClick={onClose}>Cerrar</button>
            <button className="btn btn-primary" onClick={onSave} disabled={saving}>
              {saving ? 'Guardando...' : 'Guardar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanySettingsModal;
